var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",staticStyle:{"height":"100%"}},[_c('TopHeader'),_vm._v(" "),_c('router-view',{staticClass:"content-box"}),_vm._v(" "),_c('Bottom',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.shieldBottom),expression:"!$route.meta.shieldBottom"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }